import { useRef } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Camera, X } from "lucide-react";
import { toast } from "sonner";

export function PhotoUpload({ value, onChange, label = "Ajouter une photo", testid = "photo-upload" }) {
  const ref = useRef(null);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
      toast.success("Photo téléversée");
    } catch { toast.error("Échec de l'upload"); }
    e.target.value = "";
  };
  return (
    <div>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={upload} data-testid={`${testid}-input`} />
      {value ? (
        <div className="relative inline-block">
          <img src={value} className="h-28 rounded-lg border border-slate-200 object-cover" alt="" />
          <button type="button" onClick={() => onChange(null)} data-testid={`${testid}-remove`}
            className="absolute -top-2 -right-2 bg-white rounded-full shadow p-1 border border-slate-200">
            <X className="w-3 h-3 text-slate-600" />
          </button>
          <button type="button" onClick={() => ref.current?.click()} data-testid={`${testid}-replace`}
            className="absolute bottom-1 right-1 text-[10px] bg-white/90 rounded px-1.5 py-0.5 border border-slate-200">
            Remplacer
          </button>
        </div>
      ) : (
        <Button type="button" variant="outline" size="sm" onClick={() => ref.current?.click()} data-testid={testid}>
          <Camera className="w-4 h-4 mr-1.5" />{label}
        </Button>
      )}
    </div>
  );
}

export function MultiPhotoUpload({ photos, onChange, testid = "multi-photo-upload" }) {
  const ref = useRef(null);
  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    for (const file of files) {
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        onChange([...photos, `${process.env.REACT_APP_BACKEND_URL}${data.url}`]);
      } catch { toast.error("Échec de l'upload"); }
    }
    e.target.value = "";
  };
  return (
    <div className="flex flex-wrap gap-2">
      <input ref={ref} type="file" accept="image/*" multiple className="hidden" onChange={upload} data-testid={`${testid}-input`} />
      {photos.map((p, i) => (
        <div key={i} className="relative">
          <img src={p} className="h-20 w-20 rounded-lg border border-slate-200 object-cover" alt="" />
          <button type="button" onClick={() => onChange(photos.filter((_, j) => j !== i))}
            data-testid={`${testid}-remove-${i}`}
            className="absolute -top-2 -right-2 bg-white rounded-full shadow p-1 border border-slate-200">
            <X className="w-3 h-3 text-slate-600" />
          </button>
        </div>
      ))}
      <button type="button" onClick={() => ref.current?.click()} data-testid={testid}
        className="h-20 w-20 rounded-lg border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400 hover:border-slate-400 hover:text-slate-500 transition-colors">
        <Camera className="w-5 h-5" />
        <span className="text-[10px] mt-0.5">Photo</span>
      </button>
    </div>
  );
}
